import {IPositionRepository} from "@/repository/position/PositionRepository.types";
import {IPosition, PositionResponseType} from "@/entity/position/position.types";
import Api from "@/repository/api";
import Position from "@/entity/position/position";
import {ResponseDataType} from "@/form/form.types";

export class PositionRepository implements IPositionRepository {
    async fetchAll(): Promise<IPosition[]> {
        const resp = await Api.get('/staff/position/get');
        const respData = resp.data as PositionResponseType[];
        return respData.map((position: PositionResponseType) => new Position(position));
    }
    async delete(data: { id: number }): Promise<ResponseDataType> {
        const resp = await Api.post('/staff/position/delete', data);
        return resp.data;
    }
}